export type PaidMediaTabId =
  | "overview"
  | "meta-ads-report"
  | "google-ads-report"
  | "tiktok-ads-report";

export const PAID_MEDIA_TAB_ITEMS: Array<{ id: PaidMediaTabId; label: string }> = [
  { id: "overview", label: "Paid Media Overview" },
  { id: "meta-ads-report", label: "Meta Ads Report" },
  { id: "google-ads-report", label: "Google Ads Report" },
];

export const PAID_MEDIA_TAB_IDS: PaidMediaTabId[] = PAID_MEDIA_TAB_ITEMS.map(tab => tab.id);

export interface PaidMediaPlatformConfig {
  sourceName: string;
  tab: PaidMediaTabId;
}

export const PAID_MEDIA_PLATFORMS: PaidMediaPlatformConfig[] = [
  { sourceName: "MetaAds", tab: "meta-ads-report" },
  { sourceName: "GoogleAds", tab: "google-ads-report" },
];

const PAID_MEDIA_OVERVIEW_MIN_PLATFORMS = 2;

export const getVisiblePaidMediaTabs = (connectedSources: readonly string[]): PaidMediaTabId[] => {
  const platformTabs = PAID_MEDIA_PLATFORMS.filter(platform =>
    connectedSources.includes(platform.sourceName)
  ).map(platform => platform.tab);
  return platformTabs.length >= PAID_MEDIA_OVERVIEW_MIN_PLATFORMS
    ? ["overview", ...platformTabs]
    : platformTabs;
};

export const PAID_MEDIA_TAB_I18N_KEYS: Record<PaidMediaTabId, string> = {
  overview: "metaAdsReport.paidMediaTabs.overview",
  "meta-ads-report": "metaAdsReport.paidMediaTabs.metaAdsReport",
  "google-ads-report": "metaAdsReport.paidMediaTabs.googleAdsReport",
  "tiktok-ads-report": "metaAdsReport.paidMediaTabs.comingSoon",
};
